module.exports = __webpack_public_path__ + "assets/img/slot_empty.6d5fc43c.png";